import { render, staticRenderFns } from "./DrugUsage.vue?vue&type=template&id=162a51b3&scoped=true"
import script from "./DrugUsage.vue?vue&type=script&lang=js"
export * from "./DrugUsage.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "162a51b3",
  null
  
)

export default component.exports